import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-aaac4368")

_pushScopeId("data-v-aaac4368")
const _hoisted_1 = { class: "flex flex--width flex--v flex--gap-20" }
const _hoisted_2 = { class: "flex flex--v flex--gap-20" }
const _hoisted_3 = { class: "flex flex--v flex--gap-5" }
const _hoisted_4 = { class: "flex flex--v flex--gap-5" }
const _hoisted_5 = { class: "flex flex--v flex--gap-5" }
const _hoisted_6 = { class: "flex flex--width flex--v flex--valign-c flex--gap-20" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BreezeValidationErrors = _resolveComponent("BreezeValidationErrors")
  const _component_BreezeLabel = _resolveComponent("BreezeLabel")
  const _component_BreezeInput = _resolveComponent("BreezeInput")
  const _component_GenericButton = _resolveComponent("GenericButton")
  const _component_Plane = _resolveComponent("Plane")
  const _component_MainPage = _resolveComponent("MainPage")

  return (_openBlock(), _createBlock(_component_MainPage, {
    title: _ctx.$trans('auth.password_reset'),
    gap: false
  }, {
    default: _withId(() => [
      _createVNode(_component_Plane, {
        class: "reset-plane",
        darker: true
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_BreezeValidationErrors),
            _createVNode("form", {
              class: "full-width",
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
            }, [
              _createVNode("div", _hoisted_2, [
                _createVNode("div", _hoisted_3, [
                  _createVNode(_component_BreezeLabel, {
                    for: "email",
                    value: _ctx.$trans('auth.email')
                  }, null, 8, ["value"]),
                  _createVNode(_component_BreezeInput, {
                    id: "email",
                    modelValue: _ctx.form.email,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.email = $event)),
                    type: "email",
                    required: "",
                    autofocus: "",
                    autocomplete: "username"
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode("div", _hoisted_4, [
                  _createVNode(_component_BreezeLabel, {
                    for: "password",
                    value: _ctx.$trans('auth.password')
                  }, null, 8, ["value"]),
                  _createVNode(_component_BreezeInput, {
                    id: "password",
                    modelValue: _ctx.form.password,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.password = $event)),
                    type: "password",
                    required: "",
                    autocomplete: "new-password"
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_BreezeLabel, {
                    for: "password_confirmation",
                    value: _ctx.$trans('auth.password_confirm')
                  }, null, 8, ["value"]),
                  _createVNode(_component_BreezeInput, {
                    id: "password_confirmation",
                    modelValue: _ctx.form.password_confirmation,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.password_confirmation = $event)),
                    type: "password",
                    required: "",
                    autocomplete: "new-password"
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode("div", _hoisted_6, [
                  _createVNode(_component_GenericButton, {
                    class: "reset-button",
                    title: _ctx.$trans('auth.password_reset'),
                    disabled: _ctx.form.processing,
                    onClick: _ctx.submit
                  }, null, 8, ["title", "disabled", "onClick"])
                ])
              ])
            ], 32)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
})